import { tokens } from 'src/design-system';
import { buttonStyle, commonStyles, commonStyleSheet } from "src/Library/CommonStyles";

export const FileVGMModalStyles = (theme) => ({
  main: {
    fontFamily: 'Open Sans',
    letterSpacing: 0,
    '& .ant-drawer-header': {
      padding: tokens.spacing.ms,
      position: 'absolute',
      zIndex: 10,
      width: '100%',
    },
    '& .ant-drawer-body': {
      marginTop: 56,
      padding: 0,
      backgroundColor: '#F1EEE7',
    },
    marginBottom: 100,
  },
  header: {
    ...commonStyleSheet.flexRow,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.h1,
    color: '#000000',
    height: 32,
  },
  saveDraftButton: {
    fontSize: tokens.fontSize.small,
    borderColor: '#999999',
    height: 28,
    marginRight: tokens.spacing.sm,
  },
  submitButton: {
    marginRight: tokens.spacing.md,
    height: 28,
    borderRadius: tokens.radius.md,
    fontSize: tokens.fontSize.small,
    backgroundColor: `${tokens.colors.primaryDark} !important`,
    border: `1px solid ${tokens.colors.primaryDark}`,
  },
  boxIcon: {
    width: '20%',
    fontSize: tokens.fontSize.h3,
    color: tokens.colors.textSecondary,
    textAlign: 'left',
  },
  nextButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    padding: '0 35px',
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.h3,
  },
  contentDiv: {
    padding: '36px 0',
    borderBottom: '1px solid rgba(0,0,0,0.15)',
  },
  box: {
    ...commonStyleSheet.flexRow,
    marginBottom: tokens.spacing.ms,
    padding: 20,
    alignItems: 'normal',
    boxSizing: 'border-box',
    border: '1px solid #F7F7F7',
    borderRadius: tokens.radius.md,
    boxShadow: '2px 2px 6px 0 rgba(0,0,0,0.05)',
    backgroundColor: tokens.colors.bgWhite,
  },
  contentHeading: {
    fontSize: tokens.fontSize.h3,
    color: '#424242',
    fontWeight: 'bold',
  },
  selectField: {
    width: '100%',
    '& .ant-select-selection__placeholder, .ant-select-search__field__placeholder': {
      fontSize: tokens.fontSize.small,
    },
    '& .ant-select-selection-selected-value': {
      fontSize: tokens.fontSize.small,
    },
  },
  label: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    marginTop: '9px',
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  textAreaField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  inputNumberField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  inputField: {
    width: '100%',
    fontSize: `${tokens.fontSize.small}px !important`,
  },
  containerDiv: {
    margin: `0 ${tokens.spacing.md}px 0 48px`,
    borderBottom: '1px solid rgba(0,0,0,0.15)',
    padding: `36px 0 ${tokens.spacing.lg}px 0`,
  },
  addContainerButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.small,
    padding: '0 15px',
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  contentLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
  },
  flexColumn: {
    ...commonStyles(theme).flexColumn,
  },
  multipleContainerInfo: {
    backgroundColor: '#F0F8FF',
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
    padding: tokens.spacing.ms,
    margin: `${tokens.spacing.lg}px ${tokens.spacing.lg}px ${tokens.spacing.lg}px 0`,
    display: 'flex',
  },
  addMore: {
    cursor: 'pointer',
    color: tokens.colors.primary,
  },
  autofillInfo: {
    color: '#666666',
    fontSize: tokens.fontSize.small,
    fontStyle: 'italic',
  },
  textAreaLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: '#303030',
    paddingRight: `${tokens.spacing.sm}px`,
  },
  datePicker: {
    width: '100%',
    '& .ant-calendar-picker-input.ant-input': {
      fontSize: `${tokens.fontSize.small}px !important`,
    },
  },
  successModal: {
    '& .ant-modal-header': {
      padding: 0,
      borderBottom: 'rgba(0,0,0,0.09)',
    },
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  successModalBody : {
    '& .ant-modal-body': {
      padding: tokens.spacing.md,
    },
  },
  suggestedActionsDiv: {
    ...commonStyles(theme).flexRow,
    marginTop: tokens.spacing.ms,
  },
  suggestedActions: {
    border: '1px solid #D9D9D9',
    borderRadius: tokens.radius.md,
    padding: '6px',
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.small,
    cursor: 'pointer',
  },
  successButton: {
    ...buttonStyle('#FFFFFF', tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
    padding: '0 20px',
  },
  successHeader: {
    backgroundColor: '#F9F9F9',
    color: '#424242',
    fontSize: tokens.fontSize.body,
    padding: `${tokens.spacing.lg}px ${tokens.spacing.md}px`,
  },
  containerWiseStatus: {
    color: '#262626',
    padding: `${tokens.spacing.xs}px ${tokens.spacing.md}px`,
    marginLeft: tokens.spacing.ms,
    borderRadius: '18px',
    fontSize: tokens.fontSize.small,
  },
  retryError: {
    fontSize: tokens.fontSize.body,
    color: '#0780FE',
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
  filedContainersDiv: {
    ...commonStyles(theme).fixedScrollbar,
    border: '1px solid #D9D9D9',
    maxHeight: '150px',
    overflow: 'auto',
    marginBottom: tokens.spacing.md,
    borderRadius: tokens.radius.md,
  },
  dot: {
    height: '12px',
    width: '12px',
    borderRadius: '20px',
    display: 'inline-block',
  },
  confirmationModal: {
    '& .ant-modal-body': {
      padding: `${tokens.spacing.lg}px 0px 0px 0px`,
      borderRadius: '5px',
    },
  },
});
